import { FormattedMessage } from 'react-intl';

import { PlayerInFixtureStatusIconType } from '@sorare/core/src/__generated__/globalTypes';
import { Tag } from '@sorare/core/src/atoms/ui/Tag';

import { GameCount } from '../GameCount';

type Props = {
  statusIconType: PlayerInFixtureStatusIconType;
  nbGames: number;
  hasTBDGames?: boolean;
};
export const PlayerGameStatus = ({
  statusIconType,
  nbGames,
  hasTBDGames = false,
}: Props) => {
  if (statusIconType === PlayerInFixtureStatusIconType.INACTIVE) {
    return (
      <Tag small color="grey" $stroke>
        <FormattedMessage
          id="PlayerGameStatus.inactive"
          defaultMessage="Inactive"
        />
      </Tag>
    );
  }
  return <GameCount nbGames={nbGames} hasTBDGames={hasTBDGames} />;
};
